import React, {useCallback, useState, useEffect, useContext} from 'react';
import {Popup, Select, setOptions, Textarea, toast, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderHelp.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Empty from "../utils/Empty";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderHelp({locale, dialog, Dialog, width}) {
  const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
  const [text, setText] = useState('');
  const [priority, setPriority] = useState('low');

  const DialogClose = useCallback(() => {
    Dialog({view: 'close'});
  }, [Dialog]);

  const ButtonHelp = () => {
    if (!text) {
      toast({message: locale.dashboardHeaderHelp.a, color: 'danger', duration: 3000, display: 'bottom'});
    } else {
      toast({message: locale.dashboardHeaderHelp.b, color: 'info', duration: 1000, display: 'bottom'});

      const message = {
        type: 'wss',
        path: 'help',
        action: 'put',
        data: {
          text: text,
          priority: priority
        }
      };
      wsCall(message);
    }
  }

  const PostHelp = useCallback(data => {
    if (data.toast) {
      toast({message: locale.dashboardHeaderHelp.c, color: 'primary', duration: 1000, display: 'bottom'});
      DialogClose();
    }
  }, [locale.dashboardHeaderHelp.c, DialogClose]);

  useEffect(() => {
    if (!Empty(wsResponse) && wsResponse.action === 'post' && wsResponse.path === 'help') {
      PostHelp(wsResponse.data);
      setWsResponse({});
    }
  }, [wsResponse, PostHelp, setWsResponse])

  return (
      <Popup className="cs-dashboard-header-help-popup" width={600} display="center" closeOnOverlayClick={false} closeOnEsc={false} scrollLock={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderHelp'} onClose={DialogClose}>
          <div className="mbsc-grid cs-dashboard-header-header-col">
              <div className="mbsc-row cs-dashboard-header-header-row">
                  {width > 576 &&
                      <div className="mbsc-col cs-dashboard-header-header-col" />
                  }
                  <div className={width > 576 ? "mbsc-col cs-dashboard-header-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-header-col"} >
                      <Button className="cs-dashboard-header-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                          {locale.dashboardHeaderHelp.d}
                      </Button>
                  </div>
                  <div className="mbsc-col cs-dashboard-header-header-col mbsc-align-right">
                      <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-close-button" onClick={() => DialogClose()} >
                          &nbsp;<FontAwesomeIcon className="cs-dashboard-header-close-icon" icon={faXmark} />
                      </Button>
                  </div>
              </div>
          </div>
          <div className="cs-dashboard-header-help-helper" >
              <p>{locale.dashboardHeaderHelp.g}</p>
          </div>
          <div className="cs-dashboard-header-help-helper" >
              <p>{locale.dashboardHeaderHelp.h}</p>
          </div>
          <div className="cs-dashboard-header-help-helper" >
              <p>{locale.dashboardHeaderHelp.i}</p>
          </div>
          <Select
              animation="slide-down"
              inputStyle="underline"
              dropdown={false}
              label={locale.dashboardHeaderHelp.f}
              labelStyle="floating"
              rows={locale.dashboardHeaderHelp.l.length}
              display="anchored"
              touchUi={false}
              data={locale.dashboardHeaderHelp.l}
              value={priority}
              onChange={args => setPriority(args.value)}
          />
          <div className="cs-dashboard-header-help-textarea">
              <Textarea inputStyle="underline" labelStyle="floating" label={locale.dashboardHeaderHelp.j} value={text} onChange={(ev) => setText(ev.target.value)} />
          </div>
          <div className="mbsc-button-group-justified cs-dashboard-header-nav-buttons">
              <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-nav-button" onClick={() => ButtonHelp()} >
                  {locale.dashboardHeaderHelp.e}
              </Button>
          </div>
      </Popup>
  );
}

export default DashboardHeaderHelp;
